import styled from 'styled-components';
import { theme } from '../../../configuration.js';

import { Link } from 'react-router-dom';

const HeaderMenuLink = styled(Link)`
  font-size: ${theme.sizes.header};
  text-transform: uppercase;
  padding: 4px 6px 4px 6px;
  margin-right: 10px;
  border-bottom: ${props => props.active === "true" ? "3px solid #dfead2" : "3px solid #ffffff"};
  color: ${theme.colours.main};
  text-decoration: none;
  
  &:hover {
    border-bottom: 3px solid ${theme.colours.main};
  }
`;

export default HeaderMenuLink;
